/**
 * Learner words for My journey record statuses. An unknown status shows no chip instead of a
 * raw server value (capture fixes PRD R3).
 */
const STATUS_LABELS: Record<string, string | null> = {
  planned: 'Planned',
  in_progress: 'In progress',
  completed: 'Done',
  deferred: 'Saved for later',
  archived: 'Dropped',
  evidence_unavailable: 'Deleted',
  // A reflection the learner saved needs no status chip.
  learner_confirmed: null,
};

export function journeyStatusLabel(status: string): string | null {
  return STATUS_LABELS[status] ?? null;
}

export function subjectCountLabel(count: number): string {
  return count === 1 ? '1 subject' : `${count} subjects`;
}
